var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"warpper"},[_c('DeviceMT5'),_c('FlexibleMT5'),_c('TimeMT5'),_c('DeepMT5')],1)}
var staticRenderFns = []

export { render, staticRenderFns }